module.exports = __webpack_public_path__ + "img/product-informationen.8ed67d92.svg";